.digger {
  padding: 84px 0;
  background: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  color: var(--color-primary-sand-100); /* PRIMARY_SAND_100 */
}

.digger__grid {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 48px;
  align-items: start;
}

.digger__kicker {
  /* Same step as the section-head kickers on this page, which run one size up. */
  font-size: 19px; /* HEADING_XS */
  /* HACK: the design's label weight is heavier than any COPY token, which tops out at 600. */
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--color-complementary-yellow); /* COMPLEMENTARY_YELLOW */
  margin: 0 0 16px;
}

.digger__title {
  font-family: var(--plume-font-display, sofia-pro, sans-serif);
  font-weight: 900;
  /* HACK: fluid display size — candidate future DS heading scale */
  font-size: clamp(26px, 3vw, 38px);
  line-height: 1.1;
  letter-spacing: -0.02em;
  color: var(--color-primary-sand-100); /* PRIMARY_SAND_100 */
  margin: 0 0 18px;
  text-wrap: balance;
}

.digger__body {
  font-size: 16px; /* COPY_M */
  line-height: 1.65;
  /* HACK: the design dims the cream over ink; no DS token for a translucent foreground. */
  color: rgba(246, 241, 235, 0.74);
  margin: 0 0 14px;
  max-width: 62ch;
}

.digger__link {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 16px; /* COPY_M */
  font-weight: 700;
  color: var(--color-complementary-yellow); /* COMPLEMENTARY_YELLOW */
  transition: color 0.18s cubic-bezier(0.04, 0.4, 0.5, 0.95);
}

.digger__link:hover {
  color: var(--color-primary-grey-000);
}

.digger__aside {
  /* HACK: a translucent cream hairline; no DS border token reads on ink. */
  border: 2px solid rgba(246, 241, 235, 0.24);
  border-radius: 18px;
  padding: 28px;
}

.digger__asideTitle {
  font-size: 13px; /* HEADING_5XS */
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--color-complementary-yellow); /* COMPLEMENTARY_YELLOW */
  margin: 0 0 14px;
}

.digger__asideBody {
  font-size: 15px; /* HEADING_4XS */
  line-height: 1.65;
  color: rgba(246, 241, 235, 0.74); /* HACK: as above */
  margin: 0;
}

@media (max-width: 1000px) {
  .digger__grid {
    grid-template-columns: 1fr;
    gap: 28px;
  }
}

@media (max-width: 768px) {
  .digger {
    padding: 56px 0;
  }
}
